import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventEmitterService {
  invokeEvent: Subject<any> = new Subject();

  constructor() {}

  userUpdated() {
    this.invokeEvent.next('user-updated');
  }
}
